@use "../../styles/breakpoint.module.scss" as *;

.tallContent {
    form {
        text-align: left;
    }

    @media ($above-mobile) {
        padding: 0 var(--spacer-48);
    }

    @media ($below-mobile) {
        padding-top: var(--spacer-24);
    }
}
